export default ({ currencyCode = false, products = [] } = {}) => {
  return {
    event: 'removeFromCart',
    ecommerce: {
      affiliation: 'MYB',
      currencyCode,
      remove: {
        products,
      },
    },
  };
};
